import styles from "./styles.module.scss"
import { Card, CardProps } from "antd"
import moment from "moment"
import { IEvent } from "pages/events/types"

import { useTranslation } from "react-i18next"

interface Props extends CardProps {
  item: IEvent
}

const EventItem: React.FC<Props> = ({
  item: { start_date, start_hour, end_hour, name, place, activity_room },
}) => {
  const { t } = useTranslation()

  return (
    <Card hoverable className={styles.eventCard}>
      <div className={styles.header}>
        <div className={styles.headerDate}>
          <p className={styles.day}>
            {t(
              `date.days.long.${moment(start_date).locale("en").format("dddd")}`
            )}
          </p>
          <p className={styles.dayNumber}>{moment(start_date).format("DD")}</p>
          <p className={styles.month}>
            {t(
              `date.months.short.${moment(start_date)
                .locale("en")
                .format("MMMM")}`
            )}
          </p>
        </div>
        <div className={styles.titleContainer}>
          <div>
            <div>
              <p>{name}</p>
              <p>
                {start_hour}
                {" - "}
                {end_hour}
              </p>
            </div>
          </div>
          <p>{place?.name ?? activity_room?.name}</p>
        </div>
      </div>
    </Card>
  )
}

export default EventItem
